import React from "react";
import _ from "lodash";
import DashboardInput from "../../../../parts/inputs/profile-dashboard";
import SvgIcon from "../../../../parts/SvgIcon";

class ProfileListItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: this.props.name || "",
      tempName: this.props.name,
      show: false,
      checked: this.props.checked || false,
      editing: false,
      creating: this.props.creating || false,
      itemSelector: this.props.itemSelector,
      showChecked: this.props.showChecked || false,
      viewportWidth: null,
    };
    this.showOptions = this.showOptions.bind(this);
    this.hideOptions = this.hideOptions.bind(this);
    this.toggleChecked = this.toggleChecked.bind(this);
    this.toggleEditing = this.toggleEditing.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.handleMobileRemove = this.handleMobileRemove.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);
  }

  updateDimensions() {
    this.setState((prevState) =>
      Object.assign({}, prevState, {
        viewportWidth: window.innerWidth,
      })
    );
  }

  componentDidMount() {
    !this.state.viewportWidth &&
      this.setState((prevState) =>
        Object.assign({}, prevState, {
          viewportWidth: window.innerWidth,
        })
      );
    window.addEventListener("resize", this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps[this.state.itemSelector] !== this.props[this.state.itemSelector]
    ) {
      const { name, checked, type, showChecked } = nextProps;
      this.setState({
        [this.state.itemSelector]: nextProps[this.state.itemSelector],
        name,
        checked,
        showChecked,
      });
    }
  }

  showOptions() {
    if (!this.state.creating) {
      this.setState({ show: true });
    }
  }

  hideOptions() {
    if (!this.state.creating) {
      this.setState({ show: false });
    }
  }

  toggleChecked() {
    if (!this.state.editing) {
      this.props.modifyCallback(
        this.props.type,
        this.props[this.state.itemSelector],
        {
          checked: !this.state.checked,
        }
      );
    }
    this.setState({ checked: !this.state.checked });
  }

  toggleEditing() {
    if (this.state.creating || this.state.editing) {
      if (!this.state.tempName.length) {
        alert("Must insert a text before saving");
        return;
      }
      this.setState({
        name: this.state.tempName,
        editing: false,
        creating: false,
      });
      this.props.modifyCallback(
        this.props.type,
        this.props[this.state.itemSelector],
        {
          name: this.state.tempName,
          checked: this.state.checked,
          creating: false,
        }
      );
      document.removeEventListener("mousedown", this.handleClick, false);
    } else if (!this.state.editing && !this.state.creating) {
      this.setState({ editing: true });
      document.addEventListener("mousedown", this.handleClick, false);
    }
  }

  handleInputChange(evt) {
    this.setState({ tempName: evt.target.value });
  }

  handleRemove() {
    if (this.state.creating || !this.state.editing) {
      this.props.removeItem(
        this.props.type,
        this.props[this.state.itemSelector],
        this.state.creating
      );
    } else if (this.state.editing) {
      document.removeEventListener("mousedown", this.handleClick, false);
      this.setState({ editing: false, name: this.props.name });
    }
  }

  handleMobileRemove() {
    this.props.removeItem(
      this.props.type,
      this.props[this.state.itemSelector],
      this.state.creating
    );
    document.removeEventListener("mousedown", this.handleClick, false);
    this.setState({ editing: false, name: this.props.name });
  }

  handleClick(e) {
    if (this.node && !this.node.contains(e.target)) {
      this.setState({
        editing: false,
        name: this.props.name,
        tempName: this.props.name,
      });
    }
  }

  render() {
    return (
      <li
        className={
          this.state.show &&
          !(this.state.viewportWidth && this.state.viewportWidth <= 960)
            ? "list active"
            : "list"
        }
        onMouseEnter={this.showOptions}
        onMouseLeave={this.hideOptions}
        style={
          this.state.show &&
          !(this.state.viewportWidth && this.state.viewportWidth <= 960)
            ? { borderColor: "#6ABF4B" }
            : {}
        }
        ref={(node) => (this.node = node)}
        onClick={
          !this.state.editing && !this.state.creating
            ? this.toggleEditing
            : null
        }
      >
        <div>
          {!(this.state.creating || false) && this.state.showChecked && (
            <SvgIcon
              alt="checked"
              src={`/img/new-icons/${
                this.state.checked ? "checked" : "unchecked"
              }-square.svg`}
              onClick={(e) => {
                e.stopPropagation();
                this.toggleChecked();
              }}
              noFilterOnLight={this.state.checked}
            />
          )}
          <span>
            {this.state.editing || this.state.creating ? (
              <DashboardInput
                value={this.state.tempName}
                handleChange={this.handleInputChange}
                editing={this.state.editing}
              />
            ) : (
              <p>{this.state.name}</p>
            )}
          </span>
          {(this.state.show ||
            this.state.creating ||
            this.state.editing ||
            (this.state.viewportWidth && this.state.viewportWidth <= 960)) && (
            <div>
              <SvgIcon
                classNames="mobile-hidden"
                alt="remove"
                src={
                  this.state.editing
                    ? "/img/new-icons/red-cross.svg"
                    : "/img/new-icons/red-trash.svg"
                }
                onClick={(e) => {
                  e.stopPropagation();
                  this.handleRemove();
                }}
                noFilterOnLight={true}
              />

              {(this.state.editing || this.state.creating) && (
                <>
                  <SvgIcon
                    classNames="only-show-mobile"
                    alt="remove"
                    src="/img/new-icons/red-trash.svg"
                    onClick={this.handleMobileRemove}
                    noFilterOnLight={true}
                  />
                  <span onClick={this.toggleEditing}>Save</span>
                </>
              )}
            </div>
          )}
        </div>
      </li>
    );
  }
}

export default ProfileListItem;
